// Angular
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
// Layout
import { LayoutConfigService, ToggleOptions } from '../../../../core/_base/layout';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import {
  AuthService,
  currentUser,
  isLoggedIn,
  Login,
  Logout,
  UserLoaded
} from '../../../../core/auth';
import { Observable } from 'rxjs';
import { User } from '@app/model/user';
import { CategoryService } from '@app/api/api';
import { environment } from '@app/../environments/environment';
import { FormControl, FormGroup } from '@angular/forms';
import {
  MxLeftPopupOption,
  PopUpLeftComponent
} from '../../../../shared/pop-up-left/pop-up-left.component';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ModalCreateSignInUpComponent } from '@app/views/pages/sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component';

import { TranslationService } from '@app/core/_base/layout';

import { SystemSettingService } from '@app/api/api';
import { SystemSettingStore } from '@app/services/change-setting.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticateService } from '@app/api/authenticate.service';
@Component({
  selector: 'kt-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit {
  // Public properties
  headerLogo: string;
  asideDisplay: boolean;
  urlLogo: string;
  logoLoaded: boolean = false;
  toggleOptions: ToggleOptions = {
    target: 'body',
    targetState: 'kt-header__topbar--mobile-on',
    togglerState: 'kt-header-mobile__toolbar-topbar-toggler--active'
  };
  private destroy$ = new Subject<void>();
  /**
   * Component constructor
   *
   * @param layoutConfigService: LayoutConfigService
   */
  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */

  searchForm = new FormGroup({
    search: new FormControl('')
  });

  host = environment.backendhost;

  iconCategoryDefault = '/assets/media/icons/svg/maintenance.svg';

  @ViewChild('popupleft', { static: false }) popupleft: PopUpLeftComponent;
  popupLeftOption: MxLeftPopupOption = {
    hideCloseButton: true,
    styleClass: 'header-category-popup',
    callBackAfterClose: () => {
      this.categoryShow = false;
      this.languageShow = false;
      this.resetMobileCategoryNavigation();
      this.cdr.detectChanges();
    }
  };

  private retryCount = 0;
  private isLoadingUser = false;

  ngOnInit() {
    this.headerLogo = this.layoutConfigService.getStickyLogo();
    this.asideDisplay = this.layoutConfigService.getConfig('aside.self.display');
    this.getListCategory();
    // isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).subscribe((loggedIn) => {
      if (loggedIn) {
        this.isLogin = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.isLogin = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    // currentUser — có giá trị sau khi API getMyInfo trả về
    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      if (res) {
        this.isLogin = true;
        this.currentUser = res;
        this.isLoadingUser = false;
      }
      this.cdr.detectChanges();
    });

    // Fallback: nếu NGRX effect không load được user sau 3s → gọi API trực tiếp
    setTimeout(() => {
      if (this.isLogin && !this.currentUser) {
        this.loadUserDirectly();
      }
    }, 3000);

    this.getLogo();
    this.subscribeToLogoUpdates();
  }

  loadUserDirectly() {
    if (this.isLoadingUser || this.currentUser) return;
    if (this.retryCount >= 3) return;
    this.retryCount++;
    this.isLoadingUser = true;
    console.log('[AUTH Mobile] Direct API call attempt', this.retryCount);

    this.authenticateService.apiAuthenticateGetMyInfoGet().subscribe(
      (res) => {
        this.isLoadingUser = false;
        if (res && res.success) {
          const user = res.user || res.data;
          if (user) {
            this.currentUser = user;
            this.isLogin = true;
            this.store.dispatch(new UserLoaded({ user: user }));
            this.cdr.detectChanges();
          } else {
            setTimeout(() => this.loadUserDirectly(), 2000);
          }
        } else {
          setTimeout(() => this.loadUserDirectly(), 2000);
        }
      },
      (error) => {
        this.isLoadingUser = false;
        console.error('[AUTH Mobile] Direct API error:', error.status, error.message);
        if (error.status !== 401 && error.status !== 403) {
          setTimeout(() => this.loadUserDirectly(), 2000);
        }
      }
    );
  }

  getLogo() {
    this.system
      .apiSystemSettingGet('type==HEADER-ICONS')
      // .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success && res.data.collection && res.data.collection.length > 0) {
            const children = res.data.collection[0].children;
            if (children && children.length > 0) {
              const logo = children.find(
                (item) => item.value && item.value !== '' && item.is_hidden === false
              );

              if (logo && logo.value) {
                this.urlLogo = environment.backendhost + logo.value + '?cb=' + Date.now();
                this.logoLoaded = true;
                console.log('Logo loaded from API:', this.urlLogo);
                this.cdr.markForCheck();
              }
            }
          }
        },
        error: (err) => {
          console.error('Error loading logo:', err);
        }
      });
  }

  subscribeToLogoUpdates() {
    this.storeSystem.settings$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (settings) => {
        if (settings && settings.logos && settings.logos.length > 0) {
          const activeLogo = settings.logos.find(
            (item) => item.value && item.value !== '' && item.is_hidden === false
          );

          if (activeLogo && activeLogo.value) {
            const baseUrl = activeLogo.value.startsWith('http')
              ? activeLogo.value
              : environment.backendhost + activeLogo.value;
            this.urlLogo = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
            this.logoLoaded = true;

            console.log('Logo updated from settings:', this.urlLogo);

            this.cdr.markForCheck();
          }
        }
      },
      error: (err) => {
        console.error('Error subscribing to settings:', err);
      }
    });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.isScrol = $(window).scrollTop() > 0 ? true : false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isScrol = $(window).scrollTop() > 0 ? true : false;
  }

  search: any = '';
  user$: Observable<User>;
  isLogin: boolean = false;
  isScrol: boolean = false;
  listCategory = [];

  selectedMobileRootCategory: any = null;
  expandedMobileChildId: string | number | null = null;
  currentUser: any = null;
  categoryShow: boolean = false;
  languageShow: boolean = false;
  listCountries = [
    {
      id: 0,
      name: 'VietNam',
      value: 'vi',
      flag: '/assets/media/flags/vietnam-flag-png-large.png'
    },
    { id: 1, name: 'Chinese', value: 'ch', flag: '/assets/media/flags/china-flag-png-large.png' },
    {
      id: 2,
      name: 'English',
      value: 'en',
      flag: '/assets/media/flags/united-kingdom-flag-png-large.png'
    }
  ];
  currentLang = '';
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private categoryService: CategoryService,
    private layoutConfigService: LayoutConfigService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private translationService: TranslationService,
    private system: SystemSettingService,
    private storeSystem: SystemSettingStore,
    private authenticateService: AuthenticateService
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (
          this.previousUrl.includes('searchresultpage') &&
          !this.currentUrl.includes('searchresultpage')
        ) {
          this.search = '';
        }
      }
    });
    this.currentLang = localStorage.getItem('language');
  }
  currentUrl: string = '';
  previousUrl: string = '';
  backend = environment.backendhost;

  get currentFlag(): string {
    const defaultFlag = '/assets/media/flags/united-kingdom-flag-png-large.png'; // Cờ mặc định
    if (!this.currentLang) {
      return defaultFlag;
    }
    const lang = this.listCountries.find((c) => c.value === this.currentLang);
    return lang ? lang.flag : defaultFlag;
  }
  openLanguageMenu() {
    this.languageShow = true; // Mở section ngôn ngữ
    this.categoryShow = false; // Đóng section danh mục (nếu đang mở)
    this.popupleft.open(); // Mở side menu
  }

  //   onOpencategory() {
  //     this.categoryShow = !this.categoryShow;
  //   }

  onOpencategory() {
    if (!this.categoryShow) {
      this.resetMobileCategoryNavigation();
    }

    this.categoryShow = !this.categoryShow;
  }
  onOpenlanguage() {
    this.languageShow = !this.languageShow;
  }
  onSaveLanguageChange(value) {
    this.translationService.setLanguage(value);
    this.currentLang = value;
  }
  //   getListCategory() {
  //     this.categoryService.apiCategoriesWithPriority(true, 'body', true).subscribe((res) => {
  //       if (res.success && res.data && res.data.length > 0) {
  //         const categories = res.data.filter(
  //           (x) => x.parent_id == null || x.parent_id == undefined || x.parent_id == ''
  //         );

  //         categories.forEach((item) => {
  //           item['children'] = res.data.filter((x) => x.parent_id == item.id);
  //           item.image = item.image ? this.host + item.image : this.iconCategoryDefault;

  //           item.expanded = false;

  //           if (item.children) {
  //             item.children.forEach((child) => {
  //               child.image = child.image ? this.host + child.image : this.iconCategoryDefault;
  //             });
  //           }
  //         });

  //         this.listCategory = this.sortTree(categories);
  //         this.cdr.detectChanges();
  //       }
  //     });
  //   }

  getListCategory() {
    this.categoryService.apiCategoriesWithPriority(true, 'body', true).subscribe((response) => {
      if (!response.success || !response.data) {
        this.listCategory = [];
        return;
      }

      this.listCategory = this.buildMobileCategoryTree(response.data);

      this.cdr.detectChanges();
    });
  }

  private buildMobileCategoryTree(
    categories: any[],
    parentId: string | number | null = null,
    depth: number = 0
  ): any[] {
    if (depth >= 3) {
      return [];
    }

    return categories
      .filter((category) => {
        if (parentId === null) {
          return (
            category.parent_id === null ||
            category.parent_id === undefined ||
            category.parent_id === ''
          );
        }

        return category.parent_id == parentId;
      })
      .map((category) => ({
        ...category,
        image: category.image ? this.host + category.image : this.iconCategoryDefault,
        children: this.buildMobileCategoryTree(categories, category.id, depth + 1)
      }))
      .sort((firstCategory, secondCategory) => {
        const firstPriority =
          firstCategory.priority != null ? firstCategory.priority : Number.MAX_SAFE_INTEGER;

        const secondPriority =
          secondCategory.priority != null ? secondCategory.priority : Number.MAX_SAFE_INTEGER;

        return firstPriority - secondPriority;
      });
  }

  sortTree(data: any[]): any[] {
    return data
      .map((item) => ({
        ...item,
        children: item.children ? this.sortTree(item.children) : []
      }))
      .sort((a, b) => {
        const pa = a.priority != null ? a.priority : Number.MAX_SAFE_INTEGER;
        const pb = b.priority != null ? b.priority : Number.MAX_SAFE_INTEGER;
        return pa - pb;
      });
  }

  toggleCategoryExpand(item: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    item.expanded = !item.expanded;
    this.cdr.detectChanges();
  }

  nextPageSearch() {
    this.router.navigate(['/searchresultpage'], {
      queryParams: { search: this.search.trim() }
    });
  }

  openNav() {
    this.popupleft.open();
    // if (screen.width <= 576) {
    // 	return;
    // }
    // let w = '50%'
    // if (screen.width <= 576) {
    // 	w = '70%'
    // }
    // document.getElementById("mySidenav").style.width = w;
    // document.body.style.overflow = "hidden";
    // let div = document.createElement("div");
    // var att = document.createAttribute("class");
    // att.value = "kt-header-menu-wrapper-overlay";
    // div.setAttributeNode(att);
    // document.getElementById("slide-bar-menu").appendChild(div)
  }

  closeNav() {
    if (screen.width <= 576) {
      return;
    }
    document.getElementById('mySidenav').style.width = '0px';
    document.body.style.overflow = 'auto';
    let els = document.getElementsByClassName('kt-header-menu-wrapper-overlay');
    if (els.length > 0) {
      els[0].remove();
    }
  }

  onClick(event) {
    if (screen.width <= 576) {
      return;
    }
    var target = event.target || event.srcElement || event.currentTarget;
    if (!document.getElementById('mySidenav').contains(target)) {
      this.closeNav();
    }
  }

  openModalSignInUp(type) {
    this.popupleft.close();
    const dialogRef = this.dialog.open(ModalCreateSignInUpComponent, {
      width: '900px',
      data: { type: type, returnUrl: location.pathname }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        if (result.event) {
          if (result.type == 'signin') {
            //this.toastr.success('Đăng nhập thành công');
          } else if (result.type == 'signup') {
            //this.toastr.success('Đăng kí thành công');
          } else {
            this.toastr.success('Thực hiện thao tác thành công');
          }
        }
      }
    });
  }

  getProductByCategory(item) {
    this.popupleft.close();
    this.router.navigate(['/searchbycategory'], {
      queryParams: {
        categoryId: item.id,
        categoryName: item.name
      }
    });
  }

  openVideoChannel() {
    this.system.apiSystemSettingGet('type==VIDEO').subscribe((res) => {
      if (res.success && res.data.collection.length > 0) {
        const children = res.data.collection[0].children;
        if (children && children.length > 0) {
          const videoUrl = children[0].value;
          if (videoUrl) {
            window.open(videoUrl, '_blank');
          }
        }
      }
    });
  }

  // Check if user has admin role
  isAdminUser(user: User | null | undefined): boolean {
    if (!user || !user.roles || !Array.isArray(user.roles)) {
      return false;
    }
    const adminRoles = ['Admin', 'Content Admin', 'Salesman'];
    return user.roles.some((role: string) => adminRoles.includes(role));
  }

  clickLogo() {
    const homeUrl = '/homepage';

    if (this.router.url.includes(homeUrl)) {
      window.scrollTo(0, 0);

      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([homeUrl]);
      });
    } else {
      this.router.navigate([homeUrl]).then(() => {
        window.scrollTo(0, 0);
      });
    }
  }

  openMobileRootCategory(category: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (!category.children || category.children.length === 0) {
      this.getProductByCategory(category);
      return;
    }

    this.selectedMobileRootCategory = category;
    this.expandedMobileChildId = null;
  }

  toggleMobileChildCategory(category: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (!category.children || category.children.length === 0) {
      this.getProductByCategory(category);
      return;
    }

    this.expandedMobileChildId = this.expandedMobileChildId === category.id ? null : category.id;
  }

  backToMobileRootCategories(event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    this.selectedMobileRootCategory = null;
    this.expandedMobileChildId = null;
  }

  resetMobileCategoryNavigation() {
    this.selectedMobileRootCategory = null;
    this.expandedMobileChildId = null;
  }
}
